import { selectChannelsPageState } from "redux/channels/selectors/selectChannelsState";
import { createSelector } from "reselect";

export const selectMasterKeyByChannelId = (id?: string) =>
  createSelector(
    [selectChannelsPageState],
    (state) => state.users.find((user) => user.id === id)?.master_application_key
  );
